import { Component, OnInit, Inject, ViewContainerRef } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import {PersonalPackagesRecord} from '../models/personalPackagesRecord.model';
import {ProfileService} from '../services/profile.service';

import { Observable, of } from 'rxjs';

@Component({
    selector: 'personal-packageDialog',
    templateUrl: './personalPackageListDialog.component.html',
})
export class PersonalPackageListDialogComponent {
  
    PersonalPackage:PersonalPackagesRecord = new PersonalPackagesRecord();
    public GetServiceName = [];

    constructor( public dialogRef: MatDialogRef<PersonalPackageListDialogComponent>,@Inject(MAT_DIALOG_DATA) public data: any, public vcRef: ViewContainerRef,
    private ProfileService:ProfileService) {
            debugger;
            if (this.data != null){ 
                this.PersonalPackage = this.data.newObj
                console.log(this.PersonalPackage);
                // this.employeeRecord.HireDt = this.employeeRecord.HireDt.transform(this.employeeRecord.HireDt, 'dd-MM-yy');
                
                
            }
            dialogRef.disableClose = true;
          
        
    }
    
    ngOnInit(){
        console.log(this.PersonalPackage)
        this.GetServices(this.PersonalPackage.PersonalPackageId);
        // this.ProfileService.GetCompanyName().subscribe(res => this.GetCompanyNameSucess(res), res => this.GetCompanyNameError(res));
        
    }

    GetServices(PersonalPackageId){
        this.ProfileService.GetServices(PersonalPackageId).subscribe(res => this.GetServicesSuccess(res), res => this.GetServicesError(res)); 
    }

    GetServicesSuccess(res){
        debugger;
        if(res._body!=null || res._body != undefined){
            this.GetServiceName = res.json();
        }
    }

    GetServicesError(res){}


    // UpdateAndInsertPersonalPackages(){
    //     console.log(this.PersonalPackage);
    //     this.ProfileService.UpdateAndInsertPersonalPackages(this.PersonalPackage).subscribe(res => this.UpdateAndInsertPersonalPackagesSucess(res), res => this.UpdateAndInsertPersonalPackagesError(res));
    // }

    UpdateAndInsertPersonalPackagesSucess(res){}

    UpdateAndInsertPersonalPackagesError(res){}

    // GetCompanyNameSucess(res){
    //     // this.GetCompanyName = res.json();
    // }

    // GetCompanyNameError(res){}

    onNoClick(): void {
        this.dialogRef.close();
    }

    UpdateAndInsertPersonalPackages(){
        this.PersonalPackage.Services = [];
        this.PersonalPackage.ServiceName.forEach(element => {
            let Data = this.GetServiceName.filter(x=>x.ServiceName==element)
            this.PersonalPackage.Services.push(Data[0]);
        });
        console.log(this.PersonalPackage)
        this.ProfileService.UpdateAndInsertPersonalPackages(this.PersonalPackage).subscribe(res => this.UpdateAndInsertPersonalPackagesSucess(res), res => this.UpdateAndInsertPersonalPackagesError(res));
    };

    // UpdatePackagesDetailsSucess(res){
    //     console.log(res.json())
    // }

    // UpdatePackagesDetailsError(res){}

  

}